import useGetSharedVehicleLookup from '/business/shared/components/questions/_util_hooks/useGetSharedVehicleLookup';

export default function useGetRailSchema({
  dealershipName: applicationDealershipName,
}: {
  dealershipName?: string | null;
}) {
  return useGetSharedVehicleLookup({
    inputLabel: 'Estimated distance travelled by rail for all employees',
    applicationDealershipName,
  });
}
